exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editable-date .text[data-v-0b7654ea]{border-bottom:1px dashed #aaa;cursor:pointer}.editable-date .template[data-v-0b7654ea]{color:#333}", ""]);

// exports
